/* src/app/components/companies/companies.component.scss */
:host {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
}
.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.page-title {
  margin: 0;
  color: #172033;
  font-size: 22px;
  line-height: 1.3;
  font-weight: 700;
  letter-spacing: -0.02em;
}
.user-section {
  min-height: calc(100vh - 80px);
  padding: 0px 20px;
  background: #f6f8fc;
}
.user-section .top-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
  padding: 5px 16px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05);
}
.user-section .top-actions .search-box {
  position: relative;
  width: 100%;
  max-width: 380px;
}
.user-section .top-actions .search-box .search-icon {
  position: absolute;
  top: 50%;
  left: 14px;
  z-index: 1;
  color: #94a3b8;
  font-size: 13px;
  transform: translateY(-50%);
  pointer-events: none;
}
.user-section .top-actions .search-box input {
  width: 100%;
  height: 40px;
  padding: 0 40px 0 38px;
  border: 1px solid #dfe4ec;
  border-radius: 8px;
  outline: none;
  background: #f8fafc;
  color: #1f2937;
  font-size: 12.5px;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    box-shadow 0.2s ease;
}
.user-section .top-actions .search-box input::placeholder {
  color: #9aa3b2;
}
.user-section .top-actions .search-box input:hover {
  border-color: #cbd5e1;
  background: #ffffff;
}
.user-section .top-actions .search-box input:focus {
  border-color: #253b80;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.08);
}
.user-section .top-actions .search-box .search-clear {
  position: absolute;
  top: 50%;
  right: 9px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  transform: translateY(-50%);
  transition: 0.2s ease;
}
.user-section .top-actions .search-box .search-clear:hover {
  background: #f1f5f9;
  color: #475569;
}
.user-section .top-actions .search-box .search-clear i {
  font-size: 10px;
}
.user-section .top-actions .action-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}
.user-section .top-actions .action-buttons .btn {
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 15px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: #ffffff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}
.user-section .top-actions .action-buttons .btn i {
  font-size: 13px;
}
.user-section .top-actions .action-buttons .btn:active {
  transform: translateY(1px);
}
.user-section .top-actions .action-buttons .btn.primary {
  border-color: #253b80;
  background: #253b80;
  color: #ffffff;
  box-shadow: 0 4px 10px rgba(37, 59, 128, 0.15);
}
.user-section .top-actions .action-buttons .btn.primary:hover {
  border-color: #1d2f68;
  background: #1d2f68;
  box-shadow: 0 6px 14px rgba(37, 59, 128, 0.2);
}
.user-section .top-actions .action-buttons .btn.info {
  border-color: #dbe3f4;
  color: #253b80;
}
.user-section .top-actions .action-buttons .btn.info:hover {
  border-color: #253b80;
  background: #eef2ff;
}
.user-section .top-actions .action-buttons .btn.success {
  border-color: #d7efdf;
  color: #16a34a;
}
.user-section .top-actions .action-buttons .btn.success:hover {
  border-color: #16a34a;
  background: #ecfdf3;
}
.user-section .table-card {
  width: 100%;
  height: auto;
  max-height: 70vh;
  overflow: auto;
  margin-bottom: 12px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05);
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.user-section .table-card::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.user-section .table-card::-webkit-scrollbar-track {
  background: transparent;
}
.user-section .table-card::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #cbd5e1;
}
.user-section .table-card .user-table {
  width: 100%;
  min-width: 720px;
  border-collapse: separate;
  border-spacing: 0;
}
.user-section .table-card .user-table thead {
  position: sticky;
  top: 0;
  z-index: 5;
  background: #f8fafc;
  line-height: 5;
}
.user-section .table-card .user-table thead th {
  height: 46px;
  padding: 0 16px;
  border-bottom: 1px solid #e5e7eb;
  color: #64748b;
  font-size: 10.5px;
  font-weight: 700;
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
.user-section .table-card .user-table thead th.action-column {
  width: 140px;
  text-align: center;
}
.user-section .table-card .user-table tbody tr {
  transition: background 0.15s ease;
}
.user-section .table-card .user-table tbody tr:hover {
  background: #fafbfe;
}
.user-section .table-card .user-table tbody tr:last-child td {
  border-bottom: 0;
}
.user-section .table-card .user-table tbody td {
  height: 62px;
  padding: 10px 16px;
  border-bottom: 1px solid #eef1f5;
  color: #475569;
  font-size: 12.5px;
  vertical-align: middle;
  white-space: nowrap;
}
.user-section .table-card .user-table .company-info {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 220px;
}
.user-section .table-card .user-table .company-avatar {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 9px;
  background: #eef2ff;
  color: #253b80;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
}
.user-section .table-card .user-table .company-details {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.user-section .table-card .user-table .company-name {
  display: block;
  overflow: hidden;
  max-width: 300px;
  color: #1f2937;
  font-size: 12.5px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-section .table-card .user-table .company-label {
  color: #94a3b8;
  font-size: 10px;
  font-weight: 500;
}
.user-section .table-card .user-table .email-info {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #475569;
  font-size: 12px;
}
.user-section .table-card .user-table .email-info i {
  color: #94a3b8;
  font-size: 12px;
}
.user-section .table-card .user-table .email-info span {
  display: block;
  overflow: hidden;
  max-width: 280px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-section .table-card .user-table .status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 75px;
  padding: 5px 9px;
  border-radius: 20px;
  font-size: 10.5px;
  font-weight: 600;
}
.user-section .table-card .user-table .status .status-dot {
  width: 6px;
  height: 6px;
  flex-shrink: 0;
  border-radius: 50%;
}
.user-section .table-card .user-table .status.active {
  background: #ecfdf3;
  color: #15803d;
}
.user-section .table-card .user-table .status.active .status-dot {
  background: #16a34a;
}
.user-section .table-card .user-table .status.inactive {
  background: #fff1f2;
  color: #be123c;
}
.user-section .table-card .user-table .status.inactive .status-dot {
  background: #dc3545;
}
.user-section .table-card .user-table .actions {
  text-align: center;
}
.user-section .table-card .user-table .actions .action-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.user-section .table-card .user-table .actions .icon-btn {
  position: relative;
  width: 31px;
  height: 31px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 7px;
  background: transparent;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}
.user-section .table-card .user-table .actions .icon-btn i {
  font-size: 12px;
}
.user-section .table-card .user-table .actions .icon-btn:hover {
  transform: translateY(-1px);
}
.user-section .table-card .user-table .actions .icon-btn:active {
  transform: translateY(0);
}
.user-section .table-card .user-table .actions .icon-btn.success {
  border-color: #d7efdf;
  background: #f0faf3;
  color: #16a34a;
}
.user-section .table-card .user-table .actions .icon-btn.success:hover {
  background: #dcf5e4;
}
.user-section .table-card .user-table .actions .icon-btn.warning {
  border-color: #f5e4c1;
  background: #fffaf0;
  color: #b77900;
}
.user-section .table-card .user-table .actions .icon-btn.warning:hover {
  background: #fff1d1;
}
.user-section .table-card .user-table .actions .icon-btn.danger {
  border-color: #f5d8dc;
  background: #fff5f6;
  color: #dc3545;
}
.user-section .table-card .user-table .actions .icon-btn.danger:hover {
  background: #ffe5e8;
}
.user-section .table-card .user-table .no-record {
  height: 280px !important;
  padding: 30px !important;
  color: #94a3b8;
  text-align: center;
  white-space: normal;
}
.user-section .table-card .user-table .empty-state {
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.user-section .table-card .user-table .empty-state-icon {
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  border-radius: 14px;
  background: #f1f5f9;
  color: #94a3b8;
}
.user-section .table-card .user-table .empty-state-icon i {
  font-size: 22px;
}
.user-section .table-card .user-table .empty-state h4 {
  margin: 0 0 5px;
  color: #334155;
  font-size: 14px;
  font-weight: 700;
}
.user-section .table-card .user-table .empty-state p {
  margin: 0;
  color: #94a3b8;
  font-size: 11.5px;
}
.user-section .table-card .user-table .empty-clear-btn {
  margin-top: 12px;
  padding: 6px 12px;
  border: 1px solid #dbe3f4;
  border-radius: 7px;
  background: #ffffff;
  color: #253b80;
  font-size: 10.5px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}
.user-section .table-card .user-table .empty-clear-btn:hover {
  border-color: #253b80;
  background: #eef2ff;
}
.user-section .pagination-container {
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 16px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  font-family: inherit;
}
.user-section .pagination-container .pagination-info {
  color: #64748b;
  font-size: 11.5px;
}
.user-section .pagination-container .pagination-info strong {
  color: #334155;
  font-weight: 700;
}
.user-section .pagination-container .pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination .small-screen {
  display: none;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li {
  display: inline-flex;
  align-items: center;
  height: 32px;
  margin: 0;
  padding: 0;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li a,
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li span {
  min-width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 7px;
  border-radius: 7px;
  font-size: 11px;
  text-decoration: none;
  transition: all 0.2s ease;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li a {
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li a:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
  color: #253b80;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li.current span {
  border: 1px solid #253b80;
  background: #253b80;
  color: #ffffff;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li.disabled {
  opacity: 0.45;
  pointer-events: none;
}
.user-section ::ng-deep .pagination-previous,
.user-section ::ng-deep .pagination-next,
.user-section ::ng-deep .pagination-link,
.user-section ::ng-deep .pagination-ellipsis {
  border: 0 !important;
  padding-top: 0 !important;
}
textarea {
  width: 100%;
  min-height: 90px;
  padding: 10px 12px;
  border: 1px solid #dfe4ec;
  border-radius: 8px;
  outline: none;
  background: #ffffff;
  color: #1f2937;
  font-family: inherit;
  font-size: 13px;
  resize: vertical;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
textarea:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.08);
}
textarea::placeholder {
  color: #a0a8b6;
}
.custom-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: none;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.custom-modal.is-active {
  display: flex;
}
.custom-modal .custom-modal-overlay {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
}
.custom-modal .custom-modal-container {
  position: relative;
  z-index: 2;
  width: min(800px, 100%);
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18);
  animation: modalSlideIn 0.22s ease;
}
.custom-modal .custom-modal-container .custom-modal-header {
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  border-bottom: 1px solid #eef1f5;
}
.custom-modal .custom-modal-container .custom-modal-header h2 {
  margin: 0;
  color: #1f2937;
  font-size: 16px;
  font-weight: 700;
}
.custom-modal .custom-modal-container .custom-modal-header .close-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 7px;
  background: #f8fafc;
  color: #64748b;
  font-size: 14px;
  cursor: pointer;
  transition: 0.2s ease;
}
.custom-modal .custom-modal-container .custom-modal-header .close-btn:hover {
  background: #fee2e2;
  color: #dc3545;
}
.custom-modal .custom-modal-container .custom-modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  scrollbar-width: thin;
}
.custom-modal .custom-modal-container .form-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.custom-modal .custom-modal-container .form-grid .input-row {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}
.custom-modal .custom-modal-container .form-grid .input-row .input-group {
  flex: 1 1 220px;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.custom-modal .custom-modal-container .form-grid .input-row .input-group label {
  margin-bottom: 6px;
  color: #475569;
  font-size: 11.5px;
  font-weight: 600;
}
.custom-modal .custom-modal-container .form-grid .input-row .input-group label span {
  color: #ef4444;
}
.custom-modal .custom-modal-container .form-grid .input-row .input-group input,
.custom-modal .custom-modal-container .form-grid .input-row .input-group select {
  width: 100%;
  height: 40px;
  padding: 0 11px;
  border: 1px solid #dfe4ec;
  border-radius: 8px;
  outline: none;
  background: #ffffff;
  color: #334155;
  font-family: inherit;
  font-size: 12px;
  transition: 0.2s ease;
}
.custom-modal .custom-modal-container .form-grid .input-row .input-group input:hover,
.custom-modal .custom-modal-container .form-grid .input-row .input-group select:hover {
  border-color: #cbd5e1;
}
.custom-modal .custom-modal-container .form-grid .input-row .input-group input:focus,
.custom-modal .custom-modal-container .form-grid .input-row .input-group select:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.08);
}
.custom-modal .custom-modal-container .form-grid .input-row .input-group form-validation {
  display: block;
  min-height: 16px;
  margin-top: 4px;
}
.custom-modal .custom-modal-container .form-grid .input-row.full-width {
  width: 100%;
}
.custom-modal .custom-modal-container .form-grid .profile-section {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0 4px;
}
.custom-modal .custom-modal-container .form-grid .profile-section .profile-wrapper {
  text-align: center;
}
.custom-modal .custom-modal-container .form-grid .profile-section .profile-wrapper .profile-image {
  width: 90px;
  height: 90px;
  display: block;
  margin: 0 auto 10px;
  object-fit: cover;
  border: 3px solid #eef2f7;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
}
.custom-modal .custom-modal-container .form-grid .profile-section .profile-wrapper .profile-action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.custom-modal .custom-modal-container .form-grid .profile-section .profile-wrapper .profile-action .file-label {
  color: #253b80;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}
.custom-modal .custom-modal-container .form-grid .profile-section .profile-wrapper .profile-action .file-label:hover {
  text-decoration: underline;
}
.custom-modal .custom-modal-container .form-grid .profile-section .profile-wrapper .profile-action .remove-btn {
  padding: 0;
  border: 0;
  background: transparent;
  color: #dc3545;
  font-size: 11px;
  cursor: pointer;
}
.custom-modal .custom-modal-container .custom-modal-footer {
  min-height: 68px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid #eef1f5;
}
.custom-modal .custom-modal-container .custom-modal-footer .primary-btn,
.custom-modal .custom-modal-container .custom-modal-footer .cancel-btn {
  min-height: 38px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}
.custom-modal .custom-modal-container .custom-modal-footer .primary-btn {
  border: 1px solid #253b80;
  background: #253b80;
  color: #ffffff;
}
.custom-modal .custom-modal-container .custom-modal-footer .primary-btn:hover:not(:disabled) {
  background: #1d2f68;
}
.custom-modal .custom-modal-container .custom-modal-footer .primary-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.custom-modal .custom-modal-container .custom-modal-footer .cancel-btn {
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
}
.custom-modal .custom-modal-container .custom-modal-footer .cancel-btn:hover {
  background: #f8fafc;
}
.user-bulk-upload-modal {
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.55);
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
}
.user-bulk-upload-modal .modal-overlay {
  position: absolute;
  inset: 0;
}
.user-bulk-upload-modal .modal-content {
  position: relative;
  z-index: 10;
  width: min(700px, 100%);
  max-height: 90vh;
  overflow-y: auto;
  padding: 24px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.2);
  animation: modalSlideIn 0.22s ease;
}
.user-bulk-upload-modal .modal-content .close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 7px;
  background: #f8fafc;
  color: #64748b;
  cursor: pointer;
  transition: 0.2s ease;
}
.user-bulk-upload-modal .modal-content .close-btn:hover {
  background: #fee2e2;
  color: #dc3545;
}
.user-bulk-upload-modal .modal-content .bulk-container {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 10px 0;
}
.user-bulk-upload-modal .modal-content .bulk-container .upload-card,
.user-bulk-upload-modal .modal-content .bulk-container .table-card {
  padding: 20px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.035);
  transition: 0.2s ease;
}
.user-bulk-upload-modal .modal-content .bulk-container .upload-card:hover,
.user-bulk-upload-modal .modal-content .bulk-container .table-card:hover {
  border-color: #dce2eb;
  box-shadow: 0 5px 15px rgba(15, 23, 42, 0.06);
}
.user-bulk-upload-modal .modal-content .bulk-container .section-title {
  margin: 0 0 5px;
  color: #1f2937;
  font-size: 15px;
  font-weight: 700;
}
.user-bulk-upload-modal .modal-content .bulk-container .section-desc {
  margin: 0 0 14px;
  color: #64748b;
  font-size: 11.5px;
  line-height: 1.6;
}
.user-bulk-upload-modal .modal-content .bulk-container .upload-guidelines {
  margin: 0 0 16px;
  padding-left: 18px;
  color: #64748b;
  font-size: 11.5px;
}
.user-bulk-upload-modal .modal-content .bulk-container .upload-guidelines li {
  margin-bottom: 6px;
}
.user-bulk-upload-modal .modal-content .bulk-container .upload-guidelines .link {
  color: #253b80;
  font-weight: 600;
  cursor: pointer;
}
.user-bulk-upload-modal .modal-content .bulk-container .upload-guidelines .link:hover {
  text-decoration: underline;
}
.user-bulk-upload-modal .modal-content .bulk-container .upload-actions,
.user-bulk-upload-modal .modal-content .bulk-container .table-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
}
.user-bulk-upload-modal .modal-content .bulk-container .btn {
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}
.user-bulk-upload-modal .modal-content .bulk-container .btn.btn-primary {
  border: 1px solid #253b80;
  background: #253b80;
  color: #ffffff;
}
.user-bulk-upload-modal .modal-content .bulk-container .btn.btn-primary:hover {
  background: #1d2f68;
}
.user-bulk-upload-modal .modal-content .bulk-container .btn.btn-primary.loading {
  opacity: 0.6;
  pointer-events: none;
}
.user-bulk-upload-modal .modal-content .bulk-container .btn.btn-secondary {
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #475569;
}
.user-bulk-upload-modal .modal-content .bulk-container .btn.btn-secondary:hover {
  background: #eef2f6;
}
.user-bulk-upload-modal .modal-content .bulk-container .btn.btn-outline {
  border: 1px solid #253b80;
  background: #ffffff;
  color: #253b80;
}
.user-bulk-upload-modal .modal-content .bulk-container .btn.btn-outline:hover {
  background: #253b80;
  color: #ffffff;
}
.user-bulk-upload-modal .modal-content .bulk-container .file-upload {
  position: relative;
  overflow: hidden;
}
.user-bulk-upload-modal .modal-content .bulk-container .file-upload input[type=file] {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.user-bulk-upload-modal .modal-content .bulk-container .file-name {
  display: block;
  margin-top: 8px;
  color: #334155;
  font-size: 11px;
  font-weight: 600;
  word-break: break-all;
}
.user-bulk-upload-modal .modal-content .bulk-container .info-banner {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 11px 13px;
  border: 1px solid #cfe4ff;
  border-radius: 8px;
  background: #eff7ff;
  color: #075985;
  font-size: 11px;
  line-height: 1.5;
}
.user-bulk-upload-modal .modal-content .bulk-container .info-banner i {
  margin-top: 2px;
}
.user-bulk-upload-modal .modal-content .bulk-container .custom-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11.5px;
}
.user-bulk-upload-modal .modal-content .bulk-container .custom-table thead {
  background: #f8fafc;
}
.user-bulk-upload-modal .modal-content .bulk-container .custom-table thead th {
  padding: 10px;
  border-bottom: 1px solid #e5e7eb;
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
  text-align: left;
  text-transform: uppercase;
}
.user-bulk-upload-modal .modal-content .bulk-container .custom-table tbody tr {
  border-bottom: 1px solid #eef1f5;
}
.user-bulk-upload-modal .modal-content .bulk-container .custom-table tbody tr:hover {
  background: #fafbfe;
}
.user-bulk-upload-modal .modal-content .bulk-container .custom-table tbody td {
  padding: 10px;
  color: #475569;
  vertical-align: middle;
}
.user-bulk-upload-modal .modal-content .bulk-container .custom-table .icon-btn {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #f3d8dc;
  border-radius: 7px;
  background: #fff5f6;
  color: #dc3545;
  cursor: pointer;
  transition: 0.2s ease;
}
.user-bulk-upload-modal .modal-content .bulk-container .custom-table .icon-btn:hover {
  background: #ffe4e7;
}
@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 900px) {
  .user-section {
    padding: 16px;
  }
  .user-section .top-actions {
    align-items: stretch;
  }
  .user-section .search-box {
    max-width: none;
    flex: 1;
  }
  .user-section .action-buttons {
    flex-shrink: 0;
  }
  .user-section .table-card {
    max-height: 65vh;
  }
}
@media (max-width: 600px) {
  .user-section {
    min-height: calc(100vh - 70px);
    padding: 10px;
  }
  .user-section .top-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    padding: 12px;
    margin-bottom: 12px;
  }
  .user-section .top-actions .search-box {
    max-width: none;
  }
  .user-section .top-actions .action-buttons {
    width: 100%;
  }
  .user-section .top-actions .action-buttons .btn {
    flex: 1;
    width: 100%;
  }
  .user-section .table-card {
    max-height: 60vh;
    border-radius: 10px;
  }
  .user-section .table-card .user-table {
    min-width: 650px;
  }
  .user-section .table-card .user-table th,
  .user-section .table-card .user-table td {
    padding: 9px 12px;
  }
  .user-section .table-card .user-table thead th {
    font-size: 9.5px;
  }
  .user-section .table-card .user-table tbody td {
    font-size: 11.5px;
  }
  .user-section .pagination-container {
    flex-direction: column;
    justify-content: center;
    gap: 10px;
    padding: 12px;
    text-align: center;
  }
  .user-section .pagination-container .pagination-controls {
    width: 100%;
  }
  .user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination {
    justify-content: center;
    flex-wrap: wrap;
  }
  .user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li {
    height: 30px;
  }
  .user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li a,
  .user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li span {
    min-width: 30px;
    height: 30px;
    font-size: 10px;
  }
  .custom-modal {
    padding: 10px;
  }
  .custom-modal .custom-modal-container {
    width: 100%;
    max-height: 94vh;
    border-radius: 13px;
  }
  .custom-modal .custom-modal-container .custom-modal-header {
    min-height: 56px;
    padding: 0 15px;
  }
  .custom-modal .custom-modal-container .custom-modal-header h2 {
    font-size: 14px;
  }
  .custom-modal .custom-modal-container .custom-modal-body {
    padding: 15px;
  }
  .custom-modal .custom-modal-container .form-grid .input-row {
    flex-direction: column;
    gap: 12px;
  }
  .custom-modal .custom-modal-container .form-grid .input-row .input-group {
    width: 100%;
    min-width: 100%;
  }
  .custom-modal .custom-modal-container .custom-modal-footer {
    padding: 10px 15px;
  }
  .custom-modal .custom-modal-container .custom-modal-footer .primary-btn,
  .custom-modal .custom-modal-container .custom-modal-footer .cancel-btn {
    flex: 1;
  }
  .user-bulk-upload-modal {
    padding: 10px;
  }
  .user-bulk-upload-modal .modal-content {
    width: 100%;
    max-height: 94vh;
    padding: 15px;
    border-radius: 13px;
  }
  .user-bulk-upload-modal .modal-content .bulk-container {
    padding: 5px 0;
  }
  .user-bulk-upload-modal .modal-content .bulk-container .upload-card,
  .user-bulk-upload-modal .modal-content .bulk-container .table-card {
    padding: 15px;
  }
  .user-bulk-upload-modal .modal-content .bulk-container .upload-actions,
  .user-bulk-upload-modal .modal-content .bulk-container .table-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .user-bulk-upload-modal .modal-content .bulk-container .upload-actions .btn,
  .user-bulk-upload-modal .modal-content .bulk-container .table-actions .btn {
    width: 100%;
  }
  .user-bulk-upload-modal .modal-content .bulk-container .custom-table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
}
@media (max-width: 400px) {
  .user-section .top-actions .action-buttons {
    flex-direction: column;
  }
  .user-section .pagination-container .pagination-info {
    font-size: 10px;
  }
}
/*# sourceMappingURL=companies.component.css.map */
